define(['vue'], function(Vue){
    return new Vue();
});


//////////////////
// WEBPACK FOOTER
// ../common/event-bus.js
// module id = 5
// module chunks = 0 1 2 3